import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable,BehaviorSubject,throwError, EMPTY } from 'rxjs';
import { map,catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { HomepageService } from './homepage.service';
import { TenantService } from './tenant.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  tetent: string = '';
  tenantLocId: any = '';
  confiGurationSetting: string = '*';
  private readonly apiUrl = environment.apiUrl;
  private readonly authApiUrl = environment.authApiUrl;
  private readonly authTokenEndpoint = `${(environment.authApiUrl || '').replace(/\/+$/, '')}/connect/token`;
  public logoutSubject = new BehaviorSubject<boolean>(false);
  logoutObservable$ = this.logoutSubject.asObservable();
  	constructor(private http: HttpClient,  private userIdle: UserIdleService, private tenantService: TenantService) { 
      this.tetent = this.tenantService.tenant;
      this.confiGurationSetting = this.tenantService.configurationSetting;
    }  	
    loginExsit: any;
    profileDetail: any;

    //To get access token using username and password.
  	authentication(username, password): Observable<any> {
     	let headers = new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded','tenant': this.tetent,'configuration' : this.confiGurationSetting });
     	let body = "client_id=surpasscloudapp&client_secret=c7f70adf-bab4-4717-ae3e-dc7c7071a445&grant_type=password&username="+username+"&password="+encodeURIComponent(password)+"&scope=offline_access";
      var self = this;
      return this.http.post(this.authTokenEndpoint, body, { headers:headers})
        	.pipe(
              //catchError(this.handleError),
          		map((response: Response) => {          		
                self.loginExsit = response;
            		return response;
        }));
    }

    //To Refresh Access token using refresh token.
    refreshAccessToken(refreshToken): Observable<any> {
      let headers = new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded','tenant': this.tetent,'configuration' : this.confiGurationSetting });
      let body = "client_id=surpasscloudapp&client_secret=c7f70adf-bab4-4717-ae3e-dc7c7071a445&grant_type=refresh_token&refresh_token="+refreshToken;
      var self = this;
      return this.http.post(this.authTokenEndpoint, body, { headers:headers})
          .pipe(
            map((response: Response) => {             
            return response;
        }));
    }

    //To get access token using facebook login.
    authFacebook(token): Observable<any> {
      let headers = new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded','tenant': this.tetent,'configuration' : this.confiGurationSetting });
      let body = "client_id=surpasscloudapp&client_secret=c7f70adf-bab4-4717-ae3e-dc7c7071a445&grant_type=facebookauth&scope=offline_access&id_token="+token;
      var self = this;
      return this.http.post(this.authTokenEndpoint, body, { headers:headers})
          .pipe(
             catchError(this.handleError),
              map((response: Response) => {             
                self.loginExsit = response;
                return response;
        }));
    }

    //To get access token using google login.
    authGoogle(token): Observable<any>{
      let headers = new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded','tenant': this.tetent,'configuration' : this.confiGurationSetting });
      let body = "client_id=surpasscloudapp&client_secret=c7f70adf-bab4-4717-ae3e-dc7c7071a445&grant_type=googleauth&scope=offline_access&id_token="+token;
      var self = this;
      return this.http.post(this.authTokenEndpoint, body, { headers:headers})
          //.pipe(
            //  map((response: Response) => {        
                //return response;
        //}));
    }

    authMicrosoft(idToken, authCode, codeVerifier = '', redirectUri = ''): Observable<any> {
      let headers = new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded','tenant': this.tetent,'configuration' : this.confiGurationSetting });
      let body = "client_id=surpasscloudapp&client_secret=c7f70adf-bab4-4717-ae3e-dc7c7071a445&grant_type=microsoftauth&scope=offline_access&id_token="+encodeURIComponent(idToken || '')+"&auth_code="+encodeURIComponent(authCode || '')+"&code_verifier="+encodeURIComponent(codeVerifier || '')+"&redirect_uri="+encodeURIComponent(redirectUri || '');
      return this.http.post(this.authTokenEndpoint, body, { headers:headers});
    }
   
    //To handle login error.
    handleError(error){
     let errorMessage = '';
     if (error.error instanceof ErrorEvent) {
       $('#loginError').text(error.error.error_description.replace(/_/g, ' '));
       $('#loginDotts').addClass('hide').removeClass('show');
     } else {
       $('#loginError').text(error.error.error_description.replace(/_/g, ' '));
       $('#loginDotts').addClass('hide').removeClass('show');
     }
     return throwError(errorMessage);
       
    }

    //To check if user is logged in or not.
    checkLogin(){
      return this.loginExsit;
    }

    //To get user's details from API
    getProfileDetail(auth,locationId): Observable<any> {
      let headers = new HttpHeaders({'Authorization':'Bearer '+auth,'tenant': this.tetent,'configuration': this.confiGurationSetting, 'locationId': locationId });
      var self = this;
      return this.http.get(this.apiUrl+'profile/me', { headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
                self.profileDetail = response.body;
                if(response.headers.get('Session-Id')){
                  this.setSessionIdHeader(response.headers.get('Session-Id'));
                }
                this.setIdleTimer();
                return response.body;
              }));
    }

    //To access only user detail (pre loggedin user)
    getProfileDetailInfo(){
      return this.profileDetail.data; 
    }

    //To send forget password mail.
    forgotPassword(email){
      let headers = new HttpHeaders({'Content-Type': 'application/json','tenant': this.tetent,'configuration': this.confiGurationSetting,'app-id' : 'opac' });
      return this.http.post(this.apiUrl+'account/forgotpassword',{email: email}, { headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {        
            if(response.headers.get('Session-Id')){
              this.setSessionIdHeader(response.headers.get('Session-Id'));
            }
            this.setIdleTimer();
            return response.body;
          }
        )
      );
    }

    //Reset password using reset link.
    resetPassword(newPassword, code, userId, locationId): Observable<any>{
      let headers = new HttpHeaders({'Content-Type': 'application/json','tenant': this.tetent,'configuration': this.confiGurationSetting,'app-id' : 'opac',locationId:locationId });
      return this.http.post(this.apiUrl+'account/resetpassword',{password: newPassword,code: code,userid: userId }, { headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
                if(response.headers.get('Session-Id')){
                  this.setSessionIdHeader(response.headers.get('Session-Id'));
                }
                this.setIdleTimer();
                return response.body;
        }));
    }

    //Update new password.
    updatePassword(newPass,oldPass, auth){
       let headers = new HttpHeaders({'Content-Type': 'application/json','tenant': this.tetent,'configuration': this.confiGurationSetting,'app-id' : 'opac','Authorization':'Bearer '+auth });
      return this.http.post(this.apiUrl+'profile/passwordreset',{password: newPass, oldPassword :oldPass }, { headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {        
                if(response.headers.get('Session-Id')){
                  this.setSessionIdHeader(response.headers.get('Session-Id'));
                }
                this.setIdleTimer();
                return response.body;
        }));
    }  

    //Get password requirement conditions.
    getPasswordRequirement(auth): Observable<any> {
      let headers = new HttpHeaders({'Content-Type':'application/json', 'Authorization':'Bearer '+auth,'tenant': this.tetent,'configuration': this.confiGurationSetting});
      var self = this;
      return this.http.get(this.apiUrl+'setting/passwordrequirement', { headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
                self.profileDetail = response.body;
                if(response.headers.get('Session-Id')){
                  this.setSessionIdHeader(response.headers.get('Session-Id'));
                }
                this.setIdleTimer();
                return response.body;
        }));
    }

    //Update temporary password.
    resetTempPassword(newPassword,locationId,auth){
       let headers = new HttpHeaders({'Content-Type': 'application/json','tenant': this.tetent,'configuration': this.confiGurationSetting,locationId: locationId, 'Authorization':'Bearer '+auth });
      return this.http.post(this.apiUrl+'profile/temporarypasswordreset',{password: newPassword}, { headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {        
                if(response.headers.get('Session-Id')){
                  this.setSessionIdHeader(response.headers.get('Session-Id'));
                }
                this.setIdleTimer();
                return response.body;
        }));
    }

    //Update email
    updateEmail(email, locationId, auth){
       let headers = new HttpHeaders({'Content-Type': 'application/json','tenant': this.tetent,'configuration': this.confiGurationSetting,'app-id' : 'opac', locationId: locationId, 'Authorization':'Bearer '+auth });
      return this.http.post(this.apiUrl+'profile/emailchange',{email: email}, { headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {        
                if(response.headers.get('Session-Id')){
                  this.setSessionIdHeader(response.headers.get('Session-Id'));
                }
                this.setIdleTimer();
                return response.body;
        }));
    }

    //Resend update email
    updateEmailResend(locationId, auth){
       let headers = new HttpHeaders({'Content-Type': 'application/json','tenant': this.tetent,'configuration': this.confiGurationSetting,'app-id' : 'opac', locationId: locationId, 'Authorization':'Bearer '+auth });
      return this.http.post(this.apiUrl+'profile/emailchangeresend',{},{ headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {        
                if(response.headers.get('Session-Id')){
                  this.setSessionIdHeader(response.headers.get('Session-Id'));
                }
                this.setIdleTimer();
                return response.body;
        }));
    }

    //Update email verify from link.s
    updateEmailClick(code, locationId, auth){
       let headers = new HttpHeaders({'Content-Type': 'application/json','tenant': this.tetent,'configuration': this.confiGurationSetting,'app-id' : 'opac', locationId: locationId, 'Authorization':'Bearer '+auth });
      return this.http.post(this.apiUrl+'account/resetemail?code='+code,{}, { headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {        
                if(response.headers.get('Session-Id')){
                  this.setSessionIdHeader(response.headers.get('Session-Id'));
                }
                this.setIdleTimer();
                return response.body;
        }));
    }
    public handleErrorMessage(error: any) {
      if (error.status == 401) {
          this.logoutSubject.next(true);
        return EMPTY;
      } else {
        return throwError(error);
      }
    }

    public setSessionIdHeader(sessionId){
      localStorage.setItem('Session-Id', sessionId);
    }

    public setIdleTimer(){
      // const gloalSetting = this.homepageService.getUpdatedConfig();
      console.log("global");
      // if(gloalSetting){
      //   this.userIdle.setConfigValues({idle:(gloalSetting.data.settings.timeout.minutes) * 60, timeout: 30, ping: 120});
      // }
    }
}